<script>
import { slugify } from '@/helpers/strings';
import { Type } from '@/models/type';

export default {
  name: 'ParametersComposer',
  template: '#parameters-composer-template',
  props: {
    node: {
      type: Object,
      required: true,
    },
    parameters: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const newParameterTemplate = () => ({
      id: '',
      name: '',
      type: 'string',
      required: false,
      validations: {},
    });

    const form = {
      parameter: newParameterTemplate(),
    };

    const addParameter = () => {
      form.parameter.required = form.parameter.name.indexOf('*') !== -1;
      form.parameter.name = form.parameter.name.trim().replaceAll('*', '');
      form.parameter.id = slugify(form.parameter.name, '_');
      if (!form.parameter.id) {
        return;
      }
      props.parameters[form.parameter.id] = form.parameter;
      form.parameter.type = Type[form.parameter.type]();

      form.parameter = newParameterTemplate();
    };

    const removeParameter = (parameter) => {
      delete props.parameters[parameter];
    };

    return {
      form,
      removeParameter,
      addParameter,
    };
  },
};
</script>
